export enum StakingStatus {
  FundingInitiated = "Funding initiated",
  StakingInProgress = "Staking in progress",
  UnstakingInProgress = "Unstaking in progress",
  UnstakingPeriodOver = "Unstaking period over",
  UnstakingFinished = "Unstaking finished",
  StakingPeriodOver = "Staking period over",
  StakingCanceled = "Staking cancelled",
}

export enum NftStakingStatus {
  UnstakingInProgress = "Unstaking in progress",
  UnstakingPeriodOver = "Unstaking period over",
}

export enum StakingType {
  UnqToken,
  UnqNFT,
}

export enum StakePeriodType {
  OneMonth = 1,
  ThreeMonths = 3,
  SixMonths = 6,
  TwelveMonths = 12,
}

export enum StakePeriodTypeSolana {
  OneMonth = "oneMonth",
  ThreeMonths = "threeMonths",
  SixMonths = "sixMonths",
  TwelveMonths = "twelveMonths",
}

export enum StakingStatusSolana {
  Funding = "funding",
  InProgress = "inProgress",
  Finished = "finished",
  Canceled = "canceled",
}

export enum StakingItemType {
  FT,
  NFT,
}

export enum Rarity {
  Common = "common",
  Rare = "rare",
  Epic = "epic",
  Legendary = "legendary",
}

export enum AdditionalRewardPercentagePerYear {
  Common = 2,
  Rare = 5,
  Epic = 15,
  Legendary = 30,
}
export enum FixedRewardPercentagePerYear {
  OneMonth = 6,
  ThreeMonths = 12,
  SixMonths = 16,
  TwelveMonths = 20,
}
